import { createContext, useState } from "react";

export const AppContext = createContext({});
export const AppContextProvider = ({ children }) => {




     const[Increment ,setIncrement] = useState(false)
     const[decrement , setDecrement] = useState(false)
     const[fullplansmodal, setFullplansmodal] = useState(false)
     const[selectedPlan, setSelectedPlan] = useState([])

    //  const boilerService = () => {
    //   const element = document.getElementById("boilerServices");
    //   if (element) {
    //     element.scrollIntoView({ behavior: "smooth" });
    //   } else {
    //     console.error("Element with ID 'boilerServices' not found.");
    //   }
    // };
     
     const boilerService = () => {
      document.getElementById("boilerServices").scrollIntoView({ behavior: "smooth" });
    };
     const handelview = () => {
      document.getElementById("card_scroll").scrollIntoView({ behavior: "smooth" });
    };
    const BoilerRepaiers =()=>{
      document.getElementById("boilerRepaier").scrollIntoView({ behavior: "smooth" });
    }







  return (
    <AppContext.Provider value={{
      Increment ,setIncrement,
      decrement , setDecrement,
      fullplansmodal, setFullplansmodal,
      selectedPlan, setSelectedPlan,handelview,BoilerRepaiers,
      boilerService
    }}>
    {children}
    </AppContext.Provider>
  )

};
